import * as ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/browser";

import App from "./app/App";

Sentry.init({ dsn: process.env.NX_REACT_APP_SENTRY_DSN || "" });
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
